import React from 'react';
import styled from 'styled-components';
import { BoldHeader2Text, Button, FlexRow, ModalWindow, SpruceHelpInlineLink, TinyBodyText } from 'ui-toolkit';
import SwitchDialogWindows from '../../../shared/SwitchDialogWindows';
import { doDeleteOrderLinkAction, eApplicationActions, useApplicationContext } from '../../../../state';
import { useAppDispatch } from 'store/store';
import { loadOrderAsyncAction } from 'store/order/batchedDispatches';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { Logger } from '../../../../ui-toolkit/logging/LoggerService';

const StyledDiv = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
  text-align: left;
  width: 520px;
`;

const StyledButton = styled(Button)`
  text-transform: uppercase;
`;

export interface IDisassociateOrderWithIdProps {}

const DisassociateOrderWithId: React.FC<IDisassociateOrderWithIdProps> = () => {
  const [context, dispatch] = useApplicationContext();
  const { data: order } = useSelectCurrentOrder();
  const dispatchRedux = useAppDispatch();
  const closeModal = () =>
    dispatch({
      type: eApplicationActions.ChangeValues,
      payload: { showDisassociateOrderWithId: null, updating: false, updated: false, error: null },
    });
  const showDefaultDialog = () =>
    dispatch({ type: eApplicationActions.ChangeValues, payload: { updating: false, updated: false, error: null } });
  const onDisassociateClick = async () => {
    if (context.showDisassociateOrderWithId) {
      dispatch({ type: eApplicationActions.ChangeValues, payload: { updating: true, updated: false } });
      try {
        await doDeleteOrderLinkAction(order.transaction.id!, context.showDisassociateOrderWithId);
        await dispatchRedux(loadOrderAsyncAction(order.transaction.id!));
      } catch (e: any) {
        dispatch({ type: eApplicationActions.ChangeValues, payload: { error: e } });
      }
      dispatch({ type: eApplicationActions.ChangeValues, payload: { updating: false, updated: true } });
    } else {
      Logger.warn('User action to unlink order when no link exists', order.transaction.id!);
      dispatch({
        type: eApplicationActions.ChangeValues,
        payload: { error: 'Order Link does not exist', updated: true },
      });
    }
  };
  return context.showDisassociateOrderWithId ? (
    <SwitchDialogWindows
      updating={context.updating}
      processingTitle="Disassociating Order..."
      updated={context.updated}
      error={context.error}
      successTitle={'Order Association has been updated'}
      successMessage={'This order is no longer associated to any order'}
      errorTitle={'This order had trouble disassociating from another order.'}
      errorMessage={
        <>
          Please try disassociating the order again. If the problem continues, please <SpruceHelpInlineLink /> to submit
          a request for help
        </>
      }
      onCancelClick={closeModal}
      onRetryClick={showDefaultDialog}
      defaultDialogComponent={
        <ModalWindow uitype={'fit'} onClose={closeModal} title={<BoldHeader2Text>Disassociate order?</BoldHeader2Text>}>
          <StyledDiv>
            <FlexRow>
              <StyledButton intent={'danger'} onClick={onDisassociateClick}>
                <TinyBodyText>Yes, disassociate orders</TinyBodyText>
              </StyledButton>
              <StyledButton intent="ghost" isInline onClick={closeModal}>
                <TinyBodyText>No, I've changed my mind</TinyBodyText>
              </StyledButton>
            </FlexRow>
          </StyledDiv>
        </ModalWindow>
      }
    />
  ) : null;
};

export default DisassociateOrderWithId;
